import ClientService from '../../../services/client-service';
import getPortfolioGroupDataQuery from '../../../graphql/query/get-portfolio-group-data.graphql';
import getPortfolioDealEmailConnectorDataQuery
  from '../../../graphql/query/get-portfolio-deal-email-connector-data.graphql';
import savePortfolioGroupDataMutation from '../../../graphql/mutation/save-portfolio-group-data.graphql';
import deletePortfolioGroupPortfolioMutation from '../../../graphql/mutation/delete-portfolio-group-portfolio.graphql';
import verifyPortfolioDealEmailConnectorMutation
  from '../../../graphql/mutation/verify-portfolio-deal-email-connector.graphql';

export default class SettingsPortfolioGroupApi {
  public static getPortfolioGroupData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getPortfolioGroupDataQuery, payload);
  }

  public static getPortfolioDealEmailConnectorData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getPortfolioDealEmailConnectorDataQuery, payload);
  }

  public static savePortfolioGroupData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(savePortfolioGroupDataMutation, payload);
  }

  public static deletePortfolioGroupPortfolio(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deletePortfolioGroupPortfolioMutation, payload);
  }

  public static verifyPortfolioDealEmailConnector(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(verifyPortfolioDealEmailConnectorMutation, payload);
  }
}
